import React, { useMemo } from 'react';
import { InputNumber, InputNumberChangeEvent } from 'primereact/inputnumber';

export interface LiliCurrencyInputExpandableProps {
    value: number | null;
    setValue: (val: number) => void;
    id?: string;
}

export const LiliCurrencyInputExpandable = ({ value, setValue, id }: LiliCurrencyInputExpandableProps) => {
  const handleChange = (e: InputNumberChangeEvent) => {
    setValue(e?.value || 0);
  };

  const computedInputWidth = useMemo(() => {
    const multiplier = 50;
    if (!value) return 'w-[120px]';
    const valueLength = value.toString().length;
    return `w-[${valueLength * multiplier}px]`;
  }, [value]);

  return (
    <InputNumber
      onChange={handleChange}
      step={0}
      inputClassName={`${computedInputWidth} min-w-[120px] max-w-[240px] bg-transparent shadow-none text-center rounded-[0px] shadow-none font-metricRMedium text-[30px] placeholder:text-bw04 text-bw08 border-b border-b-action03 !outline-none drop-shadow-none`}
      unstyled
      inputId={id || 'currency-us'}
      value={value || null}
      mode='currency'
      placeholder='$0.00'
      currency='USD'
      locale='en-US'
      min={0}
      max={9999999}
      minFractionDigits={2}
      maxFractionDigits={2}
    />
  );
};
